function updatePriceOnPriceContainers(priceContainers, isPair) {
  priceContainers.forEach((priceContainer) => {
    const priceContainerRef = priceContainer.querySelector('[ref="priceContainer"]');
    if(!priceContainerRef) return;

    // Helper format money BRL
    const formatMoney = (cents) => {
      const value = cents / 100;
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      });
    };

    const priceEl = priceContainerRef.querySelector('.price');
    const comparePriceEl = priceContainerRef.querySelector('.compare-at-price');
    
    let currentPrice = 0;

    // Update main price
    if (priceEl) {
      const singlePrice = parseInt(priceEl.dataset.priceSingle);
      const pairPrice = parseInt(priceEl.dataset.pricePair);
      
      if (!isNaN(singlePrice) && !isNaN(pairPrice)) {
        currentPrice = isPair ? pairPrice : singlePrice;
        priceEl.textContent = formatMoney(currentPrice);
      }
    }

    // Update compare at price
    if (comparePriceEl) {
      const singleCompare = parseInt(comparePriceEl.dataset.priceSingle);
      const pairCompare = parseInt(comparePriceEl.dataset.pricePair);
      
      if (!isNaN(singleCompare) && !isNaN(pairCompare)) {
        const currentCompare = isPair ? pairCompare : singleCompare;
        comparePriceEl.textContent = formatMoney(currentCompare);
      }
    }

    // Update Installments
    const installmentsEl = priceContainerRef.querySelector('.installments');
    if (installmentsEl && currentPrice > 0) {
      const maxInstallments = parseInt(installmentsEl.dataset.maxInstallments) || 12;
      const minInstallmentValue = parseInt(installmentsEl.dataset.minInstallmentValue) || 1000;
      const pricePixText = installmentsEl.dataset.pricePix?.trim() || null;
      const showSlash = installmentsEl.dataset.showSlash == 'true';
      console.log('showSlash:', showSlash, installmentsEl.dataset.showSlash, installmentsEl.dataset);
      
      let installments = Math.floor(currentPrice / minInstallmentValue);
      
      // Use the smaller value between max_installments and calculated installments
      if (installments > maxInstallments) {
        installments = maxInstallments;
      }
      
      // Logic to show/hide and update text
      if (currentPrice > minInstallmentValue && installments > 1) {
        const installmentPrice = Math.floor(currentPrice / installments);
        const formattedInstallmentPrice = formatMoney(installmentPrice);
        
        // Pix calculation (assuming 10% discount)
        const discountPercent = 10;
        const discountValue = Math.floor(currentPrice * discountPercent / 100);
        const pricePix = currentPrice - discountValue;
        const formattedPixPrice = formatMoney(pricePix);
        
        if(pricePixText) {
          installmentsEl.innerHTML = `${showSlash ? '|' : ''} ${installments}x ${formattedInstallmentPrice} ou ${formattedPixPrice} no pix`;
        } else {
          installmentsEl.innerHTML = `${showSlash ? '|' : ''} ${installments}x ${formattedInstallmentPrice}`;
        }
        installmentsEl.style.display = '';
      } else {
        installmentsEl.style.display = 'none';
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
    // Inicializar funcionalidade para cada produto na página
    const productCards = document.querySelectorAll('.product-card-add-to-cart');
    
    productCards.forEach(function(card) {
      initializeCustomProductOptions(card);
    });
    
    function initializeCustomProductOptions(card) {
      const customOptions = card.querySelector('.custom-product-options');
      
      // Se não há opções customizadas, mostrar botão diretamente
      if (!customOptions) {
        initializeSimpleAddToCart(card);
        return;
      }
      
      const productId = customOptions.dataset.productId;
      const totalOptions = parseInt(customOptions.dataset.totalOptions);
      const hasSinglePair = customOptions.dataset.hasSinglePair === 'true';
      const hasPersonalizacao = customOptions.dataset.hasPersonalizacao === 'true';
      const productDataScript = customOptions.querySelector('.product-data');
      
      // Calcular quantas opções são realmente de variantes (para validação)
      let personalizacaoCount = 0;
      if (hasPersonalizacao) {
        const personalizacaoGroups = customOptions.querySelectorAll('.option-group.personalizacao-option');
        personalizacaoCount = personalizacaoGroups.length;
      }
      const totalVariantOptions = totalOptions - (hasSinglePair ? 1 : 0) - personalizacaoCount;
      
      if (!productDataScript) return;
      
      let productData;
      try {
        productData = JSON.parse(productDataScript.textContent);
      } catch (e) {
        console.error('Erro ao parsear dados do produto:', e);
        return;
      }
      
      const optionGroups = customOptions.querySelectorAll('.option-group');
      const addToCartContainer = card.querySelector('.product-add-to-cart-container');
      const addToCartButton = card.querySelector('.add-to-cart-button');
      const selectionMessage = card.querySelector('.product-selection-message');
      
      let currentStep = 0;
      let selectedOptions = {};
      let currentVariant = null;
      let personalizacaoValues = {};
      
      // Função para mostrar próxima opção
      function showNextOption() {
        // Ocultar label da opção atual
        if (currentStep > 0) {
          const currentGroup = optionGroups[currentStep - 1];
          const label = currentGroup.querySelector('.option-label');
          if (label) {
            label.style.display = 'none';
          }
        }
        
        // Mostrar próxima opção se existir
        if (currentStep < totalOptions) {
          const nextGroup = optionGroups[currentStep];
          if (nextGroup) {
            nextGroup.style.display = 'block';
          }
        }
        
        updateVariantAndButton(card);
      }
      
      // Função para encontrar a variante baseada nas opções selecionadas
      // Função para encontrar a variante baseada nas opções selecionadas
      function findMatchingVariant() {
        const variants = productData.product.variants;
  
        for (let variant of variants) {
          let matches = true;
  
          // Verifica se todas as opções selecionadas coincidem (sem considerar single ou pair)
          for (let optionIndex in selectedOptions) {
            const selectedValue = selectedOptions[optionIndex];
            const variantValue = variant.options[parseInt(optionIndex)];
  
            if (selectedValue !== variantValue) {
              matches = false;
              break;
            }
          }
  
          // Retorna a variante se todas as opções foram selecionadas e coincidem
          if (matches && Object.keys(selectedOptions).length === productData.product.options.length) {
            return variant;
          }
        }
  
        return null;
      }

      function updatePriceBasedOnSinglePair(card) {
        const singlePairRadio = card?.querySelector('input[name^="single_pair_"]:checked');
        const priceContainers = card?.closest('product-card')?.querySelectorAll('product-price');
        if (priceContainers && priceContainers.length > 0 && singlePairRadio) {
          const isPair = singlePairRadio.value === 'pair';
          updatePriceOnPriceContainers(priceContainers, isPair);
        }
      }
      
      // Função para atualizar variante e botão
      function updateVariantAndButton(card) {
        currentVariant = findMatchingVariant();
  
        const allOptionsSelected = Object.keys(selectedOptions).length === totalVariantOptions;
        
        // Debug temporário
        // Verificar se personalizações obrigatórias estão preenchidas
        let personalizacoesOk = true;
        if (hasPersonalizacao) {
          const personalizacaoGroups = customOptions.querySelectorAll('.option-group.personalizacao-option');

          console.log('Personalizações encontradas:', personalizacaoGroups);
          
          // Verificar se cada grupo de personalização tem um valor
          personalizacaoGroups.forEach(group => {
            const hasTextInput = group.querySelector('input[data-personalizacao-field]');
            const hasRadioSelection = group.querySelector('input[type="radio"]:checked');

            console.log('Grupo de personalização:', group);
            console.log('Has text input:', hasTextInput);
            console.log('Has radio selection:', hasRadioSelection);
            
            if (hasTextInput) {
              // Para modo livre, verificar se tem texto
              if (!hasTextInput.value.trim()) {
                personalizacoesOk = false;
                console.log('Personalização texto vazia:', hasTextInput);
              }
            } else {
              // Para modo seleção, verificar se tem opção selecionada
              if (!hasRadioSelection) {
                personalizacoesOk = false;
                console.log('Personalização seleção não marcada no grupo:', group);
              }
            }
          });
        }

        const singlePairRadio = card.querySelector('input[name^="single_pair_"]:checked');
        updatePriceBasedOnSinglePair(card);

        console.log('=== DEBUG OPÇÕES ===');
        console.log('Total opções:', totalOptions);
        console.log('Total opções de variante:', totalVariantOptions);
        console.log('Has single/pair:', hasSinglePair);
        console.log('Single/pair value:', singlePairRadio?.value);
        console.log('Has personalização:', hasPersonalizacao);
        console.log('Personalização count:', personalizacaoCount);
        console.log('Opções selecionadas:', Object.keys(selectedOptions).length);
        console.log('Selected options:', selectedOptions);
        console.log('Todas selecionadas?', allOptionsSelected);
        console.log('Personalizações OK?', personalizacoesOk);
        console.log('Current variant:', currentVariant);
        console.log('Current variant available?', currentVariant ? currentVariant.available : 'N/A');
        if (hasPersonalizacao) {
          const personalizacaoGroups = customOptions.querySelectorAll('.option-group.personalizacao-option');
          console.log('Grupos de personalização encontrados:', personalizacaoGroups.length);
          personalizacaoGroups.forEach((group, index) => {
            const textInput = group.querySelector('input[data-personalizacao-field]');
            const radioInput = group.querySelector('input[type="radio"]:checked');
            console.log(`Grupo ${index}: texto=${textInput ? textInput.value : 'N/A'}, radio=${radioInput ? radioInput.value : 'N/A'}`);
          });
        }
        console.log('=== FIM DEBUG ===');

        if (allOptionsSelected && currentVariant && currentVariant.available && personalizacoesOk) {
          // Todas as opções selecionadas, variante disponível e personalizações OK
          addToCartContainer.style.display = 'block';
          addToCartButton.disabled = false;
          
          if (selectionMessage) {
            selectionMessage.style.display = 'none';
          }
        } else {
          // Ocultar botão se não todas as opções estão selecionadas
          addToCartContainer.style.display = 'none';
          addToCartButton.disabled = true;
          
          if (selectionMessage) {
            selectionMessage.style.display = 'block';
            const instruction = selectionMessage.querySelector('.selection-instruction');
            if (instruction) {
              if (!allOptionsSelected) {
                instruction.textContent = 'Por favor, selecione todas as opções para adicionar ao carrinho.';
              } else if (!personalizacoesOk) {
                instruction.textContent = 'Por favor, preencha todos os campos de personalização.';
              } else if (currentVariant && !currentVariant.available) {
                instruction.textContent = 'Esta variante está esgotada.';
              } else {
                instruction.textContent = 'Esta variante não está disponível.';
              }
            }
          }
        }
      }
      
      // Inicializar personalização de seleção (radio buttons marcados por padrão)
      if (hasPersonalizacao) {
        const personalizacaoGroups = customOptions.querySelectorAll('.option-group.personalizacao-option');
        personalizacaoGroups.forEach((group, index) => {
          const checkedRadio = group.querySelector('input[type="radio"]:checked');
          if (checkedRadio) {
            const personalizacaoId = checkedRadio.dataset.personalizacaoId || index.toString();
            personalizacaoValues[personalizacaoId] = {
              label: checkedRadio.dataset.optionName,
              value: checkedRadio.value
            };
            console.log(`Personalização ${personalizacaoId} inicializada:`, personalizacaoValues[personalizacaoId]);
          }
        });
      }
      
      // Event listeners para as opções
      customOptions.addEventListener('change', function(e) {
        if (e.target.classList.contains('option-input')) {
          const optionIndex = e.target.dataset.optionIndex;
          const optionName = e.target.dataset.optionName;
          const optionValue = e.target.dataset.optionValue || e.target.value;
          
          // Verificar se é personalização
          const isPersonalizacao = e.target.hasAttribute('data-personalizacao-field') || 
                                   e.target.closest('.personalizacao-option');
          
          if (isPersonalizacao) {
            // Obter ID da personalização para múltiplas personalizações
            const personalizacaoId = e.target.dataset.personalizacaoId || '0';
            
            // Salvar valor da personalização
            personalizacaoValues[personalizacaoId] = {
              label: optionName,
              value: optionValue
            };
            console.log(`Personalização ${personalizacaoId} atualizada via change:`, personalizacaoValues[personalizacaoId]);
          } else {
            // Salvar a seleção normal de variante
            if(optionIndex) {
              selectedOptions[optionIndex] = optionValue;
            }
          }
          
          // Avançar para próxima opção se não for a última
          if (currentStep < totalOptions - 1) {
            currentStep++;
            setTimeout(showNextOption, 300);
          } else {
            // Se é a última opção, ocultar o label
            const currentGroup = optionGroups[currentStep];
            const label = currentGroup.querySelector('.option-label');
            if (label) {
              label.style.display = 'none';
            }
            const card = e.target.closest('.product-card-add-to-cart');
            updateVariantAndButton(card);
          }
        }
      });
      
      // Event listener especial para campos de texto da personalização
      customOptions.addEventListener('input', function(e) {
        if (e.target.hasAttribute('data-personalizacao-field')) {
          const optionName = e.target.dataset.optionName;
          const optionValue = e.target.value;
          const personalizacaoId = e.target.dataset.personalizacaoId || '0';
          
          // Atualizar valor da personalização em tempo real
          personalizacaoValues[personalizacaoId] = {
            label: optionName,
            value: optionValue
          };
          
          // Atualizar contador se existir
          const counter = e.target.closest('.personalizacao-input-wrapper');
          if (counter) {
            const countElement = counter.querySelector('.personalizacao-count');
            const maxElement = counter.querySelector('.personalizacao-max');
            if (countElement) {
              countElement.textContent = optionValue.length;
              
              // Colorir contador baseado no limite
              const maxLength = parseInt(e.target.getAttribute('maxlength'));
              if (optionValue.length >= maxLength * 0.9) {
                countElement.style.color = 'var(--color-warning, #ff6b35)';
              } else if (optionValue.length >= maxLength * 0.75) {
                countElement.style.color = 'var(--color-accent, #ffa500)';
              } else {
                countElement.style.color = '';
              }
            }
          }
          
          // Para personalizações, também atualizar o botão
          const card = e.target.closest('.product-card-add-to-cart');
          updateVariantAndButton(card);
        }
      });
      
      // Event listener para o botão de adicionar ao carrinho
      addToCartButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (!currentVariant || !currentVariant.available) {
          return;
        }
        
        // Verificar se é produto com opção single/pair
        let quantity = 1;
        const singlePairRadio = card.querySelector('input[name^="single_pair_"]:checked');
        if (singlePairRadio && singlePairRadio.value === 'pair') {
          quantity = 2;
        }
        
        // Adicionar ao carrinho
        addToCart(currentVariant.id, quantity, addToCartButton);
      });
      
      // Função para adicionar ao carrinho
      async function addToCart(variantId, quantity, button) {
        button.disabled = true;
        button.classList.add('loading');
        
        try {
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', quantity);
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
          
          // Adicionar propriedades de personalização se existirem
          if (Object.keys(personalizacaoValues).length > 0) {
            // Debug temporário
            console.log('=== DEBUG PERSONALIZAÇÕES PRODUCT CARD ===');
            
            Object.keys(personalizacaoValues).forEach(personalizacaoId => {
              const personalizacao = personalizacaoValues[personalizacaoId];
              if (personalizacao.label && personalizacao.value) {
                formData.append(`properties[${personalizacao.label}]`, personalizacao.value);
                
                console.log(`Personalização ${personalizacaoId}:`, personalizacao.label, '=', personalizacao.value);
              }
            });
            
            // Adicionar informações de controle
            const personalizacaoLabels = Object.values(personalizacaoValues)
              .filter(p => p.label && p.value)
              .map(p => p.label)
              .join(', ');
              
            if (personalizacaoLabels) {
              formData.append('properties[_personalizacao_labels]', personalizacaoLabels);
            }
            
            console.log('=== FIM DEBUG ===');
          }
          
          const shopifyRoutes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(shopifyRoutes + 'cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          
          const responseData = await response.json();
          
          // Sucesso - mostrar feedback
          button.classList.add('added');
          
          // Criar e disparar evento CartAddEvent para integrar com o sistema do tema
          const cartAddEvent = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: responseData,
              sourceId: variantId.toString(),
              data: {
                source: 'product-card-custom',
                itemCount: quantity,
                productId: productData.product.id.toString(),
                variantId: variantId.toString(),
                sections: responseData.sections || {}
              }
            }
          });
          
          // Disparar o evento no documento para que o tema possa reagir
          document.dispatchEvent(cartAddEvent);
          
          // Abrir carrinho lateral se disponível
          openCartDrawer();
          
          // Reset após 2 segundos
          setTimeout(() => {
            button.disabled = false;
            button.classList.remove('loading', 'added');
          }, 2000);
          
        } catch (error) {
          console.error('Erro ao adicionar ao carrinho:', error);
          button.disabled = false;
          button.classList.remove('loading');
          
          // Mostrar erro mais amigável
          const errorMessage = error.message.includes('sold out') || error.message.includes('esgotado') 
            ? 'Este produto está esgotado.' 
            : 'Erro ao adicionar produto ao carrinho. Tente novamente.';
          
          alert(errorMessage);
        }
      }
      
      // Função para abrir carrinho lateral
      function openCartDrawer() {
        // Método 1: Tentar abrir via custom element cart-drawer-component
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && 'open' in cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
          return;
        }
        
        // Método 2: Tentar clicar no botão do carrinho que abre o drawer
        const cartButton = document.querySelector('[aria-controls="cart-drawer"], .cart-drawer-trigger, [data-action="open-cart-drawer"]');
        if (cartButton && 'click' in cartButton && typeof cartButton.click === 'function') {
          cartButton.click();
          return;
        }
        
        // Método 3: Disparar evento customizado como fallback
        document.dispatchEvent(new CustomEvent('open:cart-drawer', { bubbles: true }));
      }
      
      // Inicializar estado
      // Mostrar primeira opção explicitamente
      showNextOption();
    }
    
    // Função para produtos sem opções customizadas
    function initializeSimpleAddToCart(card) {
      const addToCartContainer = card.querySelector('.product-add-to-cart-container');
      const addToCartButton = card.querySelector('.add-to-cart-button');
      const selectionMessage = card.querySelector('.product-selection-message');
      
      // Mostrar botão diretamente
      if (addToCartContainer) {
        addToCartContainer.style.display = 'block';
        addToCartContainer.classList.add('all-options-selected');
      }
      
      if (addToCartButton) {
        addToCartButton.disabled = false;
      }
      
      // Ocultar mensagem de seleção
      if (selectionMessage) {
        selectionMessage.style.display = 'none';
      }
      
      // Verificar se há dados do produto para funcionalidade básica
      const productDataScript = card.querySelector('.product-data');
      if (!productDataScript) return;
      
      let productData;
      try {
        productData = JSON.parse(productDataScript.textContent);
      } catch (e) {
        console.error('Erro ao parsear dados do produto:', e);
        return;
      }
      
      // Event listener para o botão de adicionar ao carrinho
      if (addToCartButton) {
        addToCartButton.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Para produtos simples, usar a primeira variante disponível
          console.log('productData', productData);
          const availableVariant = productData.variants.find(variant => variant.available);
          
          if (!availableVariant) {
            alert('Este produto está esgotado.');
            return;
          }
          
          // Adicionar ao carrinho com quantidade 1
          addToCartSimple(availableVariant.id, 1, addToCartButton);
        });
      }
    }
    
    // Função simplificada para adicionar ao carrinho (produtos sem customização)
    async function addToCartSimple(variantId, quantity, button) {
      button.disabled = true;
      button.classList.add('loading');
      
      try {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        formData.append('sections', 'cart-drawer,cart-icon-bubble');
        
        const shopifyRoutes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(shopifyRoutes + 'cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const responseData = await response.json();
        
        // Sucesso - mostrar feedback
        button.classList.add('added');
        
        // Criar e disparar evento CartAddEvent para integrar com o sistema do tema
        const cartAddEvent = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: responseData,
            sourceId: variantId.toString(),
            data: {
              source: 'product-card-simple',
              itemCount: quantity,
              variantId: variantId.toString(),
              sections: responseData.sections || {}
            }
          }
        });
        
        // Disparar o evento no documento para que o tema possa reagir
        document.dispatchEvent(cartAddEvent);
        
        // Abrir carrinho lateral se disponível
        openCartDrawerSimple();
        
        // Reset após 2 segundos
        setTimeout(() => {
          button.disabled = false;
          button.classList.remove('loading', 'added');
        }, 2000);
        
      } catch (error) {
        console.error('Erro ao adicionar ao carrinho:', error);
        button.disabled = false;
        button.classList.remove('loading');
        
        // Mostrar erro mais amigável
        const errorMessage = error.message.includes('sold out') || error.message.includes('esgotado') 
          ? 'Este produto está esgotado.' 
          : 'Erro ao adicionar produto ao carrinho. Tente novamente.';
        
        alert(errorMessage);
      }
    }
    
    // Função para abrir carrinho lateral (versão simplificada)
    function openCartDrawerSimple() {
      // Método 1: Tentar abrir via custom element cart-drawer-component
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && 'open' in cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
        return;
      }
      
      // Método 2: Tentar clicar no botão do carrinho que abre o drawer
      const cartButton = document.querySelector('[aria-controls="cart-drawer"], .cart-drawer-trigger, [data-action="open-cart-drawer"]');
      if (cartButton && 'click' in cartButton && typeof cartButton.click === 'function') {
        cartButton.click();
        return;
      }
      
      // Método 3: Disparar evento customizado como fallback
      document.dispatchEvent(new CustomEvent('open:cart-drawer', { bubbles: true }));
    }
  });


// Mega Menu Mobile
document.addEventListener('DOMContentLoaded', function() {
  const megaMenus = document.querySelectorAll('[data-mega-menu-mobile]');
  
  megaMenus.forEach(function(megaMenu) {
    const triggerHandle = megaMenu.getAttribute('data-trigger-handle');
    const closeButtons = megaMenu.querySelectorAll('[data-mega-menu-close]');
    
    // Encontrar o link do menu horizontal que deve acionar este mega menu
    if (triggerHandle) {
      const triggerLink = document.querySelector('#MenuItem-' + triggerHandle);
      
      if (triggerLink) {
        // Interceptar o clique no link do menu
        triggerLink.addEventListener('click', function(e) {
          e.preventDefault();
          openMegaMenu(megaMenu);
        });
      }
    }
    
    // Fechar mega menu
    closeButtons.forEach(function(closeButton) {
      closeButton.addEventListener('click', function() {
        closeMegaMenu(megaMenu);
      });
    });
    
    // Fechar com ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && megaMenu.classList.contains('is-open')) {
        closeMegaMenu(megaMenu);
      }
    });
  });
  
  function openMegaMenu(megaMenu) {
    // Fechar outros mega menus que possam estar abertos
    document.querySelectorAll('[data-mega-menu-mobile].is-open').forEach(function(openMenu) {
      if (openMenu !== megaMenu) {
        closeMegaMenu(openMenu);
      }
    });
    
    megaMenu.style.display = 'block';
    document.body.classList.add('mega-menu-mobile-open');
    
    // Pequeno delay para permitir a transição
    setTimeout(function() {
      megaMenu.classList.add('is-open');
    }, 10);
    
    // Focus trap
    trapFocus(megaMenu);
  }
  
  function closeMegaMenu(megaMenu) {
    megaMenu.classList.remove('is-open');
    document.body.classList.remove('mega-menu-mobile-open');
    
    // Aguardar a transição antes de esconder
    setTimeout(function() {
      megaMenu.style.display = 'none';
    }, 300);
    
    // Restaurar focus
    releaseFocus();
  }
  
  function trapFocus(element) {
    const focusableElements = element.querySelectorAll(
      'a[href], button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );
    
    if (focusableElements.length === 0) return;
    
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    
    // Focus no primeiro elemento
    firstElement.focus();
    
    element.addEventListener('keydown', function(e) {
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          // Shift + Tab
          if (document.activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
          }
        } else {
          // Tab
          if (document.activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
          }
        }
      }
    });
  }
  
  function releaseFocus() {
    // Remover event listeners de focus trap se necessário
    // Não implementado nesta versão básica
  }
});

//funcao que ad como dataset a altura scrollada da página com debounce para nao pesar
document.addEventListener('DOMContentLoaded', function() {
  const scrollHeight = window.scrollY;
  document.body.dataset.scrollHeight = scrollHeight + 'px';
  document.body.dataset.scrolled = scrollHeight > 0 ? 'true' : 'false';
});
document.addEventListener('scroll', function() {
  const scrollHeight = window.scrollY;
  document.body.dataset.scrollHeight = scrollHeight + 'px';
  document.body.dataset.scrolled = scrollHeight > 0 ? 'true' : 'false';
});

// Função para gerenciar estado ativo do menu de políticas
function updateActivePolicyButton() {
  const buttons = document.querySelectorAll('.lista-menu-politicas .button-secondary, .institucional-pages a');
  let activeButton = null;

  buttons.forEach(function(button) {
    // Comparar URL completa para garantir precisão
    if (button.href === window.location.href) {
      button.classList.add('active');
      activeButton = button;
    } else {
      button.classList.remove('active');
    }
  });

  // Centralizar o botão ativo no container com overflow
  if (activeButton) {
    // Tenta encontrar o container de scroll
    const container = activeButton.closest('.group-block-content') || activeButton.parentElement;
    
    if (container) {
      // Calcular o scroll para centralizar o botão ativo
      const containerRect = container.getBoundingClientRect();
      const buttonRect = activeButton.getBoundingClientRect();
      
      // Posição relativa do botão + scroll atual
      const offsetLeft = buttonRect.left - containerRect.left + container.scrollLeft;
      
      // Centralizar: posição do botão - metade do container + metade do botão
      const scrollTo = offsetLeft - (container.clientWidth / 2) + (activeButton.clientWidth / 2);
      
      container.scrollTo({
        left: scrollTo,
        behavior: 'smooth'
      });
    }
  }
}

// Inicializar no load
document.addEventListener('DOMContentLoaded', updateActivePolicyButton);

// Interceptar cliques no menu de políticas para navegação sem scroll
document.addEventListener('DOMContentLoaded', function() {
  // Usar delegação de eventos no document para garantir que funcione mesmo se o menu for substituído
  // Mas como vamos substituir o MainContent, o listener precisa ser reatribuído ou estar no document
  
  // Vamos usar um listener no body que filtra cliques no menu
  document.body.addEventListener('click', function(e) {
    const link = e.target.closest('.lista-menu-politicas .button-secondary, .institucional-pages a');
    
    if (!link) return;
    
    // Verificar se é um link interno
    if (link.hostname === window.location.hostname) {
      e.preventDefault();
      const url = link.href;
      
      // Evitar recarregar a mesma página
      if (url === window.location.href) return;
      
      // Feedback visual de carregamento
      const mainContent = document.getElementById('MainContent');
      if(mainContent) mainContent.style.opacity = '0.5';

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(html, 'text/html');
          const newMainContent = newDoc.getElementById('MainContent');
          
          if (newMainContent && mainContent) {
            // Salvar posição do scroll atual
            const scrollY = window.scrollY;
            
            // Substituir conteúdo
            mainContent.innerHTML = newMainContent.innerHTML;
            
            // Atualizar URL
            window.history.pushState({path: url}, '', url);
            
            // Restaurar opacidade
            mainContent.style.opacity = '1';
            
            // Garantir scroll na posição correta
            window.scrollTo(0, scrollY);
            
            // Atualizar botões ativos
            updateActivePolicyButton();
            
            // Disparar eventos para plugins/tema
            document.dispatchEvent(new CustomEvent('page:loaded', { detail: { url: url } }));
            
            // Re-inicializar scripts específicos se necessário
            // Ex: Se houver scripts que rodam em DOMContentLoaded e afetam o conteúdo novo
          } else {
            // Fallback
            window.location.href = url;
          }
        })
        .catch(err => {
          console.error('Erro na navegação:', err);
          window.location.href = url;
        });
    }
  });
});

// Handle browser back/forward buttons
window.addEventListener('popstate', function() {
    location.reload(); 
});

// Update nomes de filtros Disponibilidade
const DISPONIBILIDADE_LABELS = {
  'Sim': 'Pronta entrega',
  'Não': 'Sob encomenda'
}
function updateFilterLabels() {
  const filtersLabels = document.querySelectorAll('span.checkbox__label-text-value, .checkbox__label-text');
  filtersLabels.forEach(function(label) {
    if(DISPONIBILIDADE_LABELS[label.innerHTML.trim()]) {
      label.innerHTML = DISPONIBILIDADE_LABELS[label.innerHTML.trim()];
    }
  });
}
setInterval(updateFilterLabels, 500);

// Função para atualizar o preço na página de produto com pair/single
(function updatePriceBasedOnSinglePair() {
  const singlePairOptions = document.querySelectorAll('.single-pair-options .variant-option__button-label');
  if(singlePairOptions.length > 0) {
    singlePairOptions.forEach(function(option) {
      option.addEventListener('click', function(e) {
        const isPair = option?.querySelector('input[name^="single_pair"]:checked')?.value === 'pair';
        console.log('isPair:', isPair);
        updatePriceOnPriceContainers(option?.closest('.product-details')?.querySelectorAll('product-price') || [], isPair);
      });
    });
    
  }
})();